import { SearchBox } from "../components/searchBox";
import logo from "../images/calidad_turistica_transparente.png";
export function Home({ searchData, changeSection }) {
  return (
    <>
      <div className="total o-secHeadHome bgCoverCenter bgHome">
        <div className="container searchBox">
          <div className="col">
            <SearchBox searchData={searchData} changeSection={changeSection} />
          </div>
          <div className="col">
            <div className="bx o-secHeadHome__txt">
              <span>
                <a
                  href="https://www.calidadendestino.es"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    className="image_banner_center"
                    src={logo}
                    //style="width: 75%"
                    alt="calidad_turistica"
                  />
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
